import React from 'react';
import { BsBugFill } from 'react-icons/bs';

const FloatingBugReport = () => {
  const handleClick = () => {
    window.open('https://docs.google.com/spreadsheets/d/1K2a8gVPJmTsnobbioQw-RpTCDL8BvRKxRRpZ0alLrtg/edit?usp=sharing', '_blank');
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#dc3545',
        color: 'white',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 2px 10px rgba(220, 53, 69, 0.3)',
        transition: 'all 0.3s ease',
        zIndex: 9999
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 4px 15px rgba(220, 53, 69, 0.4)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 2px 10px rgba(220, 53, 69, 0.3)';
      }}
      title="Báo lỗi"
    >
      <BsBugFill size={24} />
    </div>
  );
};

export default FloatingBugReport; 